<div class='e-btn-group' [formGroup]="form">
  @for (item of keyList; track item) {
    <input type="radio" [id]="id + '-' + item.key" formControlName="formValue" [value]="item.key"/>
    <label [class]="class" [ngClass]="{'single-element': keyList?.length === 1}" [for]="id + '-' + item.key">{{ item.value | translate }}</label>
  }
</div>
